// import { apiEleg } from '../../config/api'
import { postWorkshopModule } from '../../config/apiSinToken'

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que envia el listado de MIPYMES que le envien la notificacion
 * Fecha: 23-11-2022
 */
export const senPendientesWorkshop = async (form) => {
  const data = await postWorkshopModule(
    `api/v1/WorkShopsPendientes/SendWorkshopsNotificacionesPendientes`,
    form,
  )
  return data
}
